import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditorJS from '@editorjs/editorjs';

import AudioInstructionModal from './AudioInstructionModal';
import { addInstructionEventByEditor } from '../utils';
import { InstructionEvent } from '../types';
import {
  setAudioInstructionId,
  setOpenAudioInstructionModal,
  setInlineAudioInstruction,
} from '../../../../store/modules/script-editor/actions';
import { selectAudioInstruction } from '../../../../store/modules/script-editor/selectors';
import { addEventListenerToAudioActions } from './utils';
import {Formik} from "formik";

type Props = {
  instanceEditor: EditorJS | undefined;
  refEditor: HTMLDivElement | null;
};

const AudioInstructionComponent = ({ instanceEditor, refEditor }: Props) => {
  const dispatch = useDispatch();
  const { isOpenModal } = useSelector(selectAudioInstruction);

  useEffect(() => {
    if (instanceEditor) {
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.OPEN_AUDIO_INSTRUCTION_MODAL,
        (data) => {
          dispatch(setOpenAudioInstructionModal(true));
          dispatch(setAudioInstructionId(data.instructionId));
          dispatch(setInlineAudioInstruction(data.isInline));
        },
      );
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.UPDATE_AUDIO_ACTION_EVENT_LISTENERS,
        // eslint-disable-next-line
        ({ refEditor, instanceEditor }) => {
          addEventListenerToAudioActions({ instanceEditor, refEditor });
        },
      );
    }
  }, [dispatch, instanceEditor]);

  useEffect(() => {
    if (instanceEditor && refEditor) {
      addEventListenerToAudioActions({ instanceEditor, refEditor });
    }
  }, [instanceEditor, refEditor]);

  if (!isOpenModal) {
    return null;
  }

  return (
    <Formik initialValues={{audio: ''}} onSubmit={()=>{}}>
      <AudioInstructionModal instanceEditor={instanceEditor} />
    </Formik>
  );
};

export default AudioInstructionComponent;
